<div [formGroup]="form" [ngClass]="isIndependentComponent ? 'grid-container-double' : 'grid-container'">
  <mat-card class="grid-item">
    <mat-card-content class="inner-container">
      <mat-form-field
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'packagingComponentSubtype') }"
        matTooltip="{{ 'component.fields.tooltips.typeOfComponent' | transloco }}">
        <mat-label class="label-large">
          {{ 'component.fields.type' | transloco: { ofComponent: componentTypeSelectionLabel } }}
        </mat-label>
        <mat-select formControlName="packagingComponentSubtypeId" (selectionChange)="onComponentTypeChange($event.value)">
          <mat-option *ngFor="let componentSubtype of componentSubtypes" [value]="componentSubtype.id">
            {{ componentSubtype.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.packagingComponentSubtypeId.errors">
          <span *ngIf="form.controls.packagingComponentSubtypeId.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="showPackagingDescription" class="form-field-wide comment-form-field" appearance="outline">
        <mat-label class="label-large">{{ 'component.fields.packagingDescription' | transloco }}</mat-label>
        <textarea class="no-resize-textarea" matInput formControlName="description"></textarea>
      </mat-form-field>

      <mat-form-field class="form-field-wide" matTooltip="{{ 'component.fields.tooltips.articleName' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.articleName' | transloco }}</mat-label>
        <input matInput formControlName="articleName" type="text" autocomplete="off" />
      </mat-form-field>

      <mat-form-field class="form-field-wide" matTooltip="{{ 'component.fields.tooltips.articleNumber' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.articleNumber' | transloco }} </mat-label>
        <input matInput formControlName="articleNumber" type="text" autocomplete="off" />
      </mat-form-field>

      <mat-form-field class="form-field-wide" [class.gtin-warning-spacing]="gtinWarning" matTooltip="{{ 'component.fields.tooltips.gtin' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.gtin' | transloco }}</mat-label>
        <input matInput formControlName="gtin" type="text" autocomplete="off" />
        <mat-hint class="validation-yellow" *ngIf="gtinWarning">
          {{ 'dataManagement.userData.userDialog.validation.gtinError' | transloco }}
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'printingCoverage') }"
        matTooltip="{{ 'component.fields.tooltips.printingCoverage' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.printingCoverage' | transloco }} </mat-label>
        <input matInput type="number" formControlName="printingCoverage" min="0" max="100" autocomplete="off" />
        <mat-error *ngIf="form.controls.printingCoverage.errors">
          <span *ngIf="form.controls.printingCoverage.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
          <span *ngIf="form.controls.printingCoverage.errors.min">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: { value: '0%' } }}
          </span>
          <span *ngIf="form.controls.printingCoverage.errors.max">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeGreaterThan' | transloco: { value: '100%' } }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="isDecoration && !isIndependentComponent"
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'surfaceRatio') }"
        matTooltip="{{ 'component.fields.tooltips.surfaceRatio' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.surfaceRatio' | transloco }}</mat-label>
        <button
          mat-icon-button
          matSuffix
          (click)="showSurfaceRatioInfo = !showSurfaceRatioInfo"
          type="button"
          cdkOverlayOrigin
          #surfaceRatioTrigger="cdkOverlayOrigin"
          color="primary">
          <mat-icon>info</mat-icon>
        </button>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="surfaceRatioTrigger"
          cdkConnectedOverlayHasBackdrop="true"
          (backdropClick)="showSurfaceRatioInfo = false"
          [cdkConnectedOverlayOpen]="showSurfaceRatioInfo">
          <app-surface-ratio-info></app-surface-ratio-info>
        </ng-template>
        <input type="number" matInput formControlName="surfaceRatio" min="0" max="100" autocomplete="off" />
        <mat-error *ngIf="form.controls.surfaceRatio.errors">
          <span *ngIf="form.controls.surfaceRatio.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
          <span *ngIf="form.controls.surfaceRatio.errors.min">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: { value: '0%' } }}
          </span>
          <span *ngIf="form.controls.surfaceRatio.errors.max">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeGreaterThan' | transloco: { value: '100%' } }}
          </span>
        </mat-error>
      </mat-form-field>

      <app-tri-state-selector
        *ngIf="!isDecoration"
        formControlName="isRigidComponent"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'isRigidComponent') }"
        [options]="flexibilityDictionary"
        label="{{ 'component.fields.flexibility' | transloco }}"
        matTooltip="{{ 'component.fields.tooltips.flexibility' | transloco }}">
      </app-tri-state-selector>

      <app-tri-state-selector
        formControlName="containsNearInfraredBarrier"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'containsNearInfraredBarrier') }"
        [options]="nirBarrierDictionary"
        label="{{ 'component.fields.containsNearInfraredBarrier' | transloco }}"
        matTooltip="{{ 'component.fields.tooltips.containsNearInfraredBarrier' | transloco }}">
      </app-tri-state-selector>

      <app-tri-state-selector
        formControlName="hasDirectContactWithProduct"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'hasDirectContactWithProduct') }"
        [options]="nirBarrierDictionary"
        label="{{ 'component.fields.hasDirectContactWithProduct' | transloco }}">
      </app-tri-state-selector>

      <mat-form-field *ngIf="isMainBody" class="form-field-wide" matTooltip="{{ 'component.fields.tooltips.fillingVolume' | transloco }}">
        <mat-label class="label-large">
          {{ 'component.fields.fillingVolume' | transloco }}
        </mat-label>
        <input matInput formControlName="volume" min="0.001" type="number" autocomplete="off" />
        <mat-error *ngIf="form.controls.volume.errors">
          <span *ngIf="form.controls.volume.errors.min">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: { value: minimalLength } }}
          </span>
        </mat-error>
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <mat-card class="grid-item">
    <mat-card-content class="inner-container">
      <mat-form-field class="form-field-wide" matTooltip="{{ 'component.fields.tooltips.manufacturer' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.manufacturer' | transloco }} </mat-label>
        <input matInput formControlName="manufacturer" type="text" autocomplete="off" />
      </mat-form-field>

      <mat-form-field
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'manufacturingLocation') }"
        matTooltip="{{ 'component.fields.tooltips.manufacturingCountry' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.manufacturingCountry' | transloco }} </mat-label>
        <mat-select formControlName="manufacturingCountry">
          <mat-option [value]="null"> {{ 'common.text.noSelection' | transloco }}</mat-option>
          <mat-option *ngFor="let country of manufacturingCountries" [value]="country.code">
            {{ country.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.manufacturingCountry.errors">
          <span *ngIf="form.controls.manufacturingCountry.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="isIndependentComponent" class="form-field-wide" matTooltip="{{ 'component.fields.tooltips.countriesOfDistribution' | transloco }}">
        <mat-label class="label-large">
          {{ 'component.fields.countriesOfDistribution' | transloco }}
        </mat-label>

        <mat-select #countrySelect class="chip-list-select" formControlName="distributionCountries" multiple>
          <app-select-all-option [matSelect]="countrySelect" [allValues]="distributionCountryCodes"> </app-select-all-option>
          <mat-option *ngFor="let country of distributionCountries" [value]="country.code">
            {{ country.name }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="form.controls.distributionCountries.errors">
          <span *ngIf="form.controls.distributionCountries.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.atLeastOneSelectionRequired' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'length') }"
        matTooltip="{{ 'component.fields.tooltips.length' | transloco }}">
        <mat-label class="label-large">
          {{ 'component.fields.length' | transloco }}
        </mat-label>
        <input matInput type="number" formControlName="length" autocomplete="off" />
        <mat-error *ngIf="form.controls.length.errors">
          <span *ngIf="form.controls.length.errors.min">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: { value: minimalLength } }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'width') }"
        matTooltip="{{ 'component.fields.tooltips.width' | transloco }}">
        <mat-label class="label-large">
          {{ 'component.fields.width' | transloco }}
        </mat-label>
        <input matInput type="number" formControlName="width" autocomplete="off" />
        <mat-error *ngIf="form.controls.width.errors">
          <span *ngIf="form.controls.width.errors.min">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: { value: minimalLength } }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'height') }"
        matTooltip="{{ 'component.fields.tooltips.height' | transloco }}">
        <mat-label class="label-large">
          {{ 'component.fields.height' | transloco }}
        </mat-label>
        <input matInput type="number" formControlName="height" autocomplete="off" />
        <mat-error *ngIf="form.controls.height.errors">
          <span *ngIf="form.controls.height.errors.min">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: { value: minimalLength } }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="!isIndependentComponent && !isInlay && !isMainBody"
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'removedBeforeUsage') }"
        matTooltip="{{ 'component.fields.tooltips.removalBeforeUsage' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.removalBeforeUsage' | transloco }} </mat-label>
        <mat-select formControlName="removedBeforeUsage" (selectionChange)="onRemovedBeforeUsageChange($event.value)">
          <mat-option *ngFor="let removed of componentRemovedDictionary" [value]="removed.key">
            {{ removed.value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.removedBeforeUsage.errors">
          <span *ngIf="form.controls.removedBeforeUsage.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="!isIndependentComponent && !isInlay && !isMainBody"
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'removedByConsumer') }"
        matTooltip="{{ 'component.fields.tooltips.removalForDisposal' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.removalForDisposal' | transloco }} </mat-label>
        <mat-select formControlName="removedByConsumer">
          <mat-option *ngFor="let removed of componentRemovedDictionary" [value]="removed.key">
            {{ removed.value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.removedByConsumer.errors">
          <span *ngIf="form.controls.removedByConsumer.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="!isIndependentComponent && !isMainBody"
        class="form-field-wide"
        [ngClass]="{
          calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'separationThroughCollectionAndSorting'),
        }"
        matTooltip="{{ 'component.fields.tooltips.seperation' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.seperation' | transloco }} </mat-label>
        <mat-select formControlName="separationThroughCollectionAndSorting">
          <mat-option *ngFor="let removed of componentRemovedDictionary" [value]="removed.key">
            {{ removed.value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.separationThroughCollectionAndSorting.errors">
          <span *ngIf="form.controls.separationThroughCollectionAndSorting.errors.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="((isDecoration && form.controls.isAdhesiveUsed) || isInlay) && !isIndependentComponent"
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'isAdhesiveUsed') }"
        matTooltip="{{ 'component.fields.tooltips.adhesivesUsed' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.adhesivesUsed' | transloco }}</mat-label>
        <mat-select formControlName="isAdhesiveUsed" (selectionChange)="onAdhesivesOptionChange($event.value)">
          <mat-option *ngFor="let used of adhesivesUsedDictionary" [value]="used.key">
            {{ used.value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.isAdhesiveUsed?.errors">
          <span *ngIf="form.controls.isAdhesiveUsed.errors?.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="((isDecoration && form.controls.removabilityConditionId) || isInlay) && !isIndependentComponent"
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'removabilityCondition') }"
        matTooltip="{{ 'component.fields.tooltips.removabilityCondition' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.removabilityCondition' | transloco }} </mat-label>
        <mat-select formControlName="removabilityConditionId">
          <mat-option *ngFor="let condition of removabilityConditions" [value]="condition.id">
            {{ condition.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.removabilityConditionId?.errors">
          <span *ngIf="form.controls.removabilityConditionId?.errors?.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="isInlay && form.controls.attachedToMainBody"
        class="form-field-wide"
        [ngClass]="{ calcRelevantInputFields: relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes, packagingPartEnum.Component, 'isPhysicallyAttached') }"
        matTooltip="{{ 'component.fields.tooltips.attachedToMainBody' | transloco }}">
        <mat-label class="label-large">{{ 'component.fields.attachedToMainBody' | transloco }} </mat-label>
        <mat-select formControlName="attachedToMainBody">
          <mat-option *ngFor="let attached of attachedToMainBodyDictionary" [value]="attached.key">
            {{ attached.value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.attachedToMainBody?.errors">
          <span *ngIf="form.controls.attachedToMainBody?.errors?.required">
            {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="form-field-wide">
        <mat-label class="label-large">
          {{ 'component.fields.totalGrammage' | transloco: { ofComponent: componentTypeSelectionLabel } }}
          {{ 'component.fields.totalGrammageUnit' | transloco }}
        </mat-label>
        <input matInput type="number" formControlName="totalGrammage" autocomplete="off" />
        <mat-error *ngIf="form.controls.totalGrammage.errors">
          <span *ngIf="form.controls.totalGrammage.errors.min">
            {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: { value: minimalLength } }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="form-field-wide">
        <mat-label class="label-large">
          {{ 'component.fields.totalWeight' | transloco: { ofComponent: componentTypeSelectionLabel } }}
          {{ 'component.fields.totalWeightUnit' | transloco }}
        </mat-label>
        <input matInput type="number" formControlName="totalWeight" autocomplete="off" />
      </mat-form-field>

      <button *ngIf="customFieldProfiles.length > 0" mat-raised-button (click)="showCustomFields()" color="primary" class="custom-fields-button" type="button">
        <mat-icon class="material-icons left">edit</mat-icon>
        {{ 'dataManagement.customFields.button' | transloco }}
      </button>
    </mat-card-content>
  </mat-card>
</div>
